<template>
  <div class="brand-list">
    <h2>Brand Listing</h2>
    <div class="brand-listing brand-listing--hero">
      <ul>
        <li
          v-for="(brand, index) in filteredBrandsHero"
          :key="'bh'+index"
          :style="brand.backgroundColor ? 'background-color: ' + brand.backgroundColor.hex + ';' : ''"
        >
          <a
            :href="brand.url"
            data-gtmcat="brand engagement"
            data-gtmaction="category click"
            :data-gtmlabel="brand.title | striphtml"
          >
            <template v-if="brand.useReversedImageOnBackgroundColor">
              <img
                :src="brand.revImage"
                :alt="brand.title"
              >
            </template>
            <template v-else>
              <img
                :src="brand.imageUrl"
                :alt="brand.title"
              >
            </template>
          </a>
        </li>
      </ul>
    </div>
    <div class="brand-listing brand-listing--non-hero">
      <ul>
        <li
          v-for="(brand, index) in filteredBrandsNonHero"
          :key="'b'+index"
        >
          <a
            :href="brand.url"
            data-gtmcat="brand engagement"
            data-gtmaction="category click"
            :data-gtmlabel="brand.title | striphtml"
          >
            <img
              :src="brand.imageUrl"
              :alt="brand.title"
            >
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import store from "../store"

export default {
  name: "BrandsView",
  computed: {
    filteredBrandsHero: function() {
      return store.state.items.filter(function(item) {
        return !item.isExcluded && item.isHero;
      });
    },
    filteredBrandsNonHero: function() {
      return store.state.items.filter(function(item) {
        return !item.isExcluded && !item.isHero;
      });
    },
  },
  created() {
    // console.log('filteredBrandsHero', this.filteredBrandsHero)
    // console.log('filteredBrandsNonHero', this.filteredBrandsNonHero)
  }
};
</script>
